const matchZoom = window.location.hash.match(/zoom=([0-9]{1,3})/);
export const zoom = matchZoom && matchZoom[1];

export const calc = (x) => zoom ? `calc${expression(x)}` : x;
export const expression = (x) => zoom ? `((${x} / ${zoom}) * 100)` : x;
